var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import cx from "clsx";
import { buildURL, buildDensities } from "../../../../marketplace-next/src/utils/image/cloudinary";
import { REGULAR_IMAGE_SIZE, REGULAR_IMAGE_MODS, ALT_IMAGE_WIDTH, ALT_IMAGE_HEIGHT, ALT_IMAGE_MODS, } from "./constants";
export var ItemImage = function (_a) {
    var _b;
    var image = _a.image, isAlternative = _a.isAlternative, title = _a.title;
    var imageSrc = image
        ? isAlternative
            ? buildURL(image.url, ALT_IMAGE_MODS)
            : buildURL(image.url, REGULAR_IMAGE_MODS)
        : undefined;
    var imageContainerClass = isAlternative ? "w-18 sm:w-22" : "w-5 md:w-6";
    // regular image is assumed to be an svg
    var imageProps = image
        ? {
            className: cx("block h-auto w-full", isAlternative ? "rounded" : "mt-0.5"),
            src: imageSrc,
            srcSet: imageSrc && isAlternative ? buildDensities(imageSrc) : undefined,
            alt: (_b = image.alt) !== null && _b !== void 0 ? _b : title,
            width: isAlternative ? ALT_IMAGE_WIDTH : REGULAR_IMAGE_SIZE,
            height: isAlternative ? ALT_IMAGE_HEIGHT : REGULAR_IMAGE_SIZE,
            loading: "lazy",
            decoding: "async",
        }
        : null;
    // eslint-disable-next-line jsx-a11y/alt-text
    return React.createElement("div", { className: imageContainerClass }, image && React.createElement("img", __assign({}, imageProps)));
};
//# sourceMappingURL=ItemImage.js.map